export const ROLES = ['admin', 'operator', 'viewer'] as const;
export type Role = (typeof ROLES)[number];

export const PERMISSIONS = [
  // infrastructure
  'do:read',
  'do:write',
  'do:delete',
  'dns:read',
  'dns:write',
  // stacks & deploys
  'stacks:read',
  'stacks:write',
  'envvars:read',
  'envvars:write',
  'deploy:read',
  'deploy:execute',
  'deploy:provision',
  'deploy:switch',
  'env:mark-healthy',
  // credentials
  'credentials:read', // metadata only (name/kind/last4) — never secret material
  'credentials:manage',
  'credentials:use',
  'github:connect',
  // administration
  'users:manage',
  'audit:read',
  'settings:manage',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const VIEWER: Permission[] = [
  'do:read',
  'dns:read',
  'stacks:read',
  'deploy:read',
];

const OPERATOR: Permission[] = [
  ...VIEWER,
  'do:write',
  'do:delete',
  'dns:write',
  'stacks:write',
  'envvars:read',
  'envvars:write',
  'deploy:execute',
  'deploy:provision',
  'deploy:switch',
  'credentials:read',
  'credentials:use',
  'github:connect',
];

const ADMIN: Permission[] = [
  ...OPERATOR,
  'env:mark-healthy',
  'credentials:manage',
  'users:manage',
  'audit:read',
  'settings:manage',
];

export const ROLE_PERMISSIONS: Record<Role, ReadonlySet<Permission>> = {
  admin: new Set(ADMIN),
  operator: new Set(OPERATOR),
  viewer: new Set(VIEWER),
};

export function hasPermission(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].has(permission);
}
